import React, { useEffect } from "react";
import { connect } from "react-redux";
import DeleteConfirmationModal from "../../../../../../../ui/DeleteConfirmationModal";

import {
  getModuleAbilityAction,
  addNewModuleAbilityAction,
  deleteModuleAbilityAction,
  updateModuleAbilityAction
} from "../../../../../store/actions";

import AddButton from "../../../../../../../ui/AddButton";

import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import DeleteForeverOutlinedIcon from "@material-ui/icons/DeleteForeverOutlined";
import ReplyOutlinedIcon from "@material-ui/icons/ReplyOutlined";
import DoneOutlinedIcon from "@material-ui/icons/DoneOutlined";

const useStyles = makeStyles({
  addButon: {
    display: "flex",
    justifyContent: "flex-end"
  },
  textFieldArea: {
    marginTop: "5px",
    "& .MuiFormControl-root": {
      marginBottom: "6px",
      "& .Mui-disabled": {
        color: "#000"
      }
    },
    "& .MuiInputBase-root": {
      width: "95%"
    },
    "& .MuiButtonBase-root": {
      padding: "6px"
    }
  },
  skillRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: "17px",
    borderTop: "1px solid #CACCD1",
    borderLeft: "1px solid #CACCD1",
    borderRight: "1px solid #CACCD1",
    "&:last-child": {
      borderBottom: "1px solid #CACCD1"
    },
    "& .MuiInputBase-multiline": {
      padding: "6px 0px"
    }
  },
  actionButton: {
    display: "flex",
    alignItems: "center"
  }
});

const EditableList = ({
  items,
  typeId,
  getModuleAbility,
  addModuleAbility,
  updateModuleAbility,
  deleteModuleAbility,
  matchId
}) => {
  const { addButon, textFieldArea, skillRow, actionButton } = useStyles();
  const [ability, setAbility] = React.useState(items);
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const [deletedAbilityId, setDeletedAbilityId] = React.useState();
  const [activeField, setActiveField] = React.useState(null);

  useEffect(() => {
    if (ability !== items && activeField === null) {
      setAbility(items);
    }
  }, [ability, activeField, items]);

  const addNewField = () => {
    const values = [...ability];
    values.unshift({
      typeId: typeId,
      number: "",
      note: ""
    });
    setAbility(values);
    setActiveField(0);
  };

  const addNewAbility = () => {
    const moduleAbility = {
      main: {
        type: typeId,
        number: ability[0].number,
        note: ability[0].note
      }
    };
    addModuleAbility(matchId, moduleAbility);
    setActiveField(null);
  };

  const editAbility = (idx, event) => {
    setActiveField(idx);
  };

  const changeInputNumber = (i, event) => {
    const values = [...ability];
    values[i].number = event.target.value;
    setAbility(values);
  };

  const changeInputNote = (i, event) => {
    const values = [...ability];
    values[i].note = event.target.value;
    setAbility(values);
  };

  const updateAbility = id => {
    const data = ability.find(item => item.id === id);
    const updateData = {
      main: {
        number: data.number,
        type: data.typeId,
        note: data.note
      }
    };
    updateModuleAbility(id, updateData);
    setActiveField(null);
  };

  const cancelEditAbility = () => {
    setActiveField(null);
    getModuleAbility(matchId);
  };

  const deleteAbility = () => {
    deleteModuleAbility(deletedAbilityId);
    setActiveField(null);
  };

  const deletedAbilityName = ability.find(item => item.id === deletedAbilityId);

  return (
    <>
      <DeleteConfirmationModal
        open={openDeleteModal}
        handleClose={() => setOpenDeleteModal(false)}
        modalText="Удалить навык?"
        additionalText={deletedAbilityName && deletedAbilityName.note}
        onConfirm={() => deleteAbility()}
      />
      <div className={addButon}>
        <AddButton onClick={() => addNewField()} />
      </div>
      <div className={textFieldArea}>
        {ability.map((item, idx) => (
          <div key={`List-${idx}`} className={skillRow}>
            <TextField
              label={!activeField && "№ п/п"}
              value={item.number ? item.number : ""}
              onChange={e => changeInputNumber(idx, e)}
              style={{ width: "5%" }}
              InputProps={{
                disableUnderline: activeField === idx ? false : true
              }}
              InputLabelProps={{
                shrink: true
              }}
              disabled={activeField === idx ? false : true}
            />
            <TextField
              label={!activeField && "Введите текст навыка"}
              value={item.note ? item.note : ""}
              onChange={e => changeInputNote(idx, e)}
              multiline
              InputProps={{
                disableUnderline: activeField === idx ? false : true
              }}
              InputLabelProps={{
                shrink: true
              }}
              disabled={activeField === idx ? false : true}
            />
            <div className={actionButton}>
              {activeField !== idx ? (
                <Tooltip title="Редактировать" placement="top-start">
                  <IconButton onClick={e => editAbility(idx, e)}>
                    <EditOutlinedIcon
                      fontSize="small"
                      style={{ color: "#93A7BE" }}
                    />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="Сохранить" placement="top-start">
                  <IconButton
                    onClick={() =>
                      item.id ? updateAbility(item.id) : addNewAbility()
                    }
                  >
                    <DoneOutlinedIcon
                      fontSize="small"
                      style={{ color: "#93A7BE" }}
                    />
                  </IconButton>
                </Tooltip>
              )}
              {activeField !== idx ? (
                <Tooltip title="Удалить" placement="top-start">
                  <IconButton
                    onClick={() =>
                      setDeletedAbilityId(item.id) || setOpenDeleteModal(true)
                    }
                  >
                    <DeleteForeverOutlinedIcon
                      fontSize="small"
                      style={{ color: "#93A7BE" }}
                    />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="Отмена" placement="top-start">
                  <IconButton onClick={cancelEditAbility}>
                    <ReplyOutlinedIcon
                      fontSize="small"
                      style={{ color: "#93A7BE" }}
                    />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  getModuleAbility: id => dispatch(getModuleAbilityAction(id)),
  addModuleAbility: (id, ability) =>
    dispatch(addNewModuleAbilityAction(id, ability)),
  updateModuleAbility: (ability, data) =>
    dispatch(updateModuleAbilityAction(ability, data)),
  deleteModuleAbility: ability => dispatch(deleteModuleAbilityAction(ability))
});

export default connect(null, mapDispatchToProps)(EditableList);
